import React, { useEffect, useState } from "react";
import vectorarrow from "../../src/Images/vectorarrow.png";
import HttpClient from "../utils/HttpClient";
import { useSelector } from "react-redux";

const Ownpagesearchkeywordmodal = ({ closemodal, result }) => {

  const initialData = {
    product: "",
    productCat: "",
    location: "",
    state: "",
    country: "",
  }
  const { UserProfileID } = useSelector((state) => state.app);
  const [arrowmodalclcik, setarrowmodalclcik] = useState(false);
  const [selectedOption, setSelectedOption] = useState("all");
  const [country, setCountry] = useState([])
  const [filterKey, setFilterKey] = useState(initialData);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [countryStates, setCountryStates] = useState([]);
  const [companyServices, setCompanyServices] = useState([]);
  const [viewAll, setViewAll] = useState(true)
  const [viewPremiumMembers, setViewPremiumMembers] = useState(false)
  const [viewVerifiedList, setViewVerifiedList] = useState(false)

  const handleInsertData = (key, value) => {
    setFilterKey({ ...filterKey, [key]: value });
  };

  const handlearrpwclick = async () => {
    const response = await HttpClient.requestData(
      "filter-business",
      "POST",
      filterKey
    );
    
    if (response?.status) {
      let resultData = response?.data
      if (viewPremiumMembers || viewVerifiedList) {
        resultData = response?.data.filter((item) => { return item.memberStatus })
      }
      result(resultData);
      closemodal()
    } else {
      console.log("Error while fetching the data ");
    }
    setarrowmodalclcik(!arrowmodalclcik);
  };

  const getCountryStates = async (id) => {
    try {
      const res = await HttpClient.requestData(
        `countrywise-state/${id}`,
        "GET"
      );
      if (res?.status) {
        setCountryStates(res.data?.[0]?.states || []);
      }
    } catch (error) {
      console.error("Error fetching country states:", error);
    }
  };

  const toggleDropdown = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  const getCompanyTypeWiseServices = async () => {
    try {
      const res = await HttpClient.requestData(
        `companyType-wise-servicess/${UserProfileID?.companyTypeID}`,
        "GET"
      );
      if (res?.status) {
        setCompanyServices(res.data.map((item) => { return { _id: item._id, name: item.name } }))
      }
    } catch (error) {
      console.error("Error occured!", error);
    }
  };

  const getTypeOfBusiness = async () => {
    try {
      const response = await HttpClient.requestData("companyType", "GET");
      if (response.status) {
        setCompanyServices(response.data);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  useEffect(() => {
    if (selectedOption === "all") {
      setViewAll(true)
      setViewPremiumMembers(false)
      setViewVerifiedList(false)
    } else if (selectedOption === "premium") {
      setViewAll(false)
      setViewPremiumMembers(true)
      setViewVerifiedList(false)
    } else {
      setViewAll(false)
      setViewPremiumMembers(false)
      setViewVerifiedList(true)
    }
  }, [selectedOption])

  const getCountry = async () => {
    const res = await HttpClient.requestData("countries", "GET", {});

    if (res && res?.status) {
      setCountry(res?.data);
    }
  }

  useEffect(() => {
    getCountryStates(filterKey.country);
  }, [filterKey.country]);

  useEffect(() => {
    // getCompanyTypeWiseServices()
    getTypeOfBusiness()
    getCountry()
    // getCountryStates()
  }, [])

  return (
    <div className="uploabannermodalbgshadow ">
      <div className="owenoagedjeywordbgmain">
        <div className="crossdivmainmnm" onClick={() => closemodal()} style={{cursor:"pointer"}}>
          <i className="fa-solid fa-xmark"></i>
        </div>

        <div className="keywirdrserchttxtdibgflxmain">
          <div className="keywirdrserchttxtdibgflx">
            <div className="keywirdrserchdibvnain">
              <p className="keywirdrserchdibvnainttxpp">Keyword</p>
            </div>
            <div className="keywirdrserchdibinpiuytxtdiv">
              <input
                type="text"
                value={filterKey?.product}
                onChange={(e) => handleInsertData("product", e.target.value)}
                className="keywprodsecrtinputmain"
                placeholder="Enter keyword"
              />
            </div>
          </div>

          <div className="keywirdrserchttxtdibgflx">
            <div className="keywirdrserchdibvnain">
              <p className="keywirdrserchdibvnainttxpp">Category</p>
            </div>
            {/* <div className="keywirdrserchdibinpiuytxtdiv">
              <div className="keywirdrserchdibderselect">
                <p className="selrcttcatreffgtxtpp">{filterKey?.productCat || "--- Select Cate ---"}</p>
                <div
                  className="vectorimgamindiv"
                  onClick={() => toggleDropdown("services")}
                >
                  <img src={vectorarrow} alt="..." />
                </div>
                {activeDropdown === "services" && (
                  <div className="vectoraarowdivomgulmai">
                    <ul className="vectoraarowdivomgulmaiul">
                      <li
                        className="vectoraarowdivomgulmaili"
                        onClick={() => {
                          handleInsertData("productCat", "")
                          toggleDropdown("services");
                        }}
                      >
                        --- Select ---
                      </li>
                      {companyServices.map((service, index) => (
                        <li
                          key={index}
                          className="vectoraarowdivomgulmaili"
                          onClick={() => {
                            handleInsertData("productCat", service?.name)
                            toggleDropdown("services");
                          }}
                        >
                          {service?.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div> */}
            <select className="neooSelect"
              value={filterKey?.productCat}
              onClick={(e) => {
                handleInsertData("productCat", e.target.value)
              }}
              style={{
                height: "44px",
                padding: "5px 10px 5px 20px",
                fontSize: "15px"
              }}
            >
              <option value="">Choose...</option>
              {
                companyServices
                  .map((item, key) => {
                    return (
                      <><option value={item?._id}>{item?.type}</option></>
                    )
                  })
              }
            </select>
          </div>

          <div className="keywirdrserchttxtdibgflx">
            <div className="keywirdrserchdibvnain">
              <p className="keywirdrserchdibvnainttxpp">Page</p>
            </div>
            {/* <div className="keywirdrserchdibinpiuytxtdiv">
              <div className="">
                <div className="chekowcutbnemttxndivflx">
                  <input
                    type="checkbox"
                    name=""
                    defaultValue=""
                    className="chekowcutomedesign"
                    onClick={() => { setViewAll(!viewAll) }}
                    checked={viewAll}
                  />
                  <label htmlFor="" className="labbnemttxptt">
                    All
                  </label>
                </div>

                <div className="chekowcutbnemttxndivflx">
                  <input
                    type="checkbox"
                    name=""
                    defaultValue=""
                    className="chekowcutomedesign"
                    onClick={() => { setViewPremiumMembers(!viewPremiumMembers) }}
                    checked={viewPremiumMembers}
                  />
                  <label htmlFor="" className="labbnemttxptt">
                    Premium Members
                  </label>
                </div>

                <div className="chekowcutbnemttxndivflx">
                  <input
                    type="checkbox"
                    name=""
                    defaultValue=""
                    className="chekowcutomedesign"
                    onClick={() => { setViewVerifiedList(!viewVerifiedList) }}
                    checked={viewVerifiedList}
                  />
                  <label htmlFor="" className="labbnemttxptt">
                    Verified list
                  </label>
                </div>
              </div>
            </div> */}

            <div className="keywirdrserchdibinpiuytxtdiv">
              <div className="">
                <div className="chekowcutbnemttxndivflx">
                  <input
                    type="checkbox"
                    className="chekowcutomedesign"
                    checked={selectedOption === "all"}
                    onChange={() => setSelectedOption("all")}
                  />
                  <label className="labbnemttxptt">All</label>
                </div>

                <div className="chekowcutbnemttxndivflx">
                  <input
                    type="checkbox"
                    className="chekowcutomedesign"
                    checked={selectedOption === "premium"}
                    onChange={() => setSelectedOption("premium")}
                  />
                  <label className="labbnemttxptt">Premium Members</label>
                </div>

                <div className="chekowcutbnemttxndivflx">
                  <input
                    type="checkbox"
                    className="chekowcutomedesign"
                    checked={selectedOption === "verified"}
                    onChange={() => setSelectedOption("verified")}
                  />
                  <label className="labbnemttxptt">Verified list</label>
                </div>
              </div>
            </div>
          </div>

          <div className="keywirdrserchttxtdibgflx">
            <div className="keywirdrserchdibvnain">
              <p className="keywirdrserchdibvnainttxpp">City/Town/Area</p>
            </div>
            <div className="keywirdrserchdibinpiuytxtdiv">
              <input
                type="text"
                value={filterKey?.location}
                onChange={(e) =>
                  setFilterKey({ ...filterKey, location: e.target.value })
                }
                className="keywprodsecrtinputmain"
                placeholder="Healthcare city"
              />
            </div>
          </div>

          <div className="keywirdrserchttxtdibgflx">
            <div className="keywirdrserchdibvnain">
              <p className="keywirdrserchdibvnainttxpp">Country</p>
            </div>
            {/* <div className="keywirdrserchdibinpiuytxtdiv">
              <div className="keywirdrserchdibderselect">
                <p className="selrcttcatreffgtxtpp">{filterKey?.country === "65f95f070d6753c3bdacccd9" ? "United Arab Emirates" : "--- Select ---"} </p>
                <div
                  className="vectorimgamindiv"
                  onClick={() => toggleDropdown("country")}
                >
                  <img src={vectorarrow} alt="..." />
                </div>
                {activeDropdown === "country" && (
                  <div className="vectoraarowdivomgulmai">
                    <ul className="vectoraarowdivomgulmaiul">
                      <li
                        className="vectoraarowdivomgulmaili"
                        onClick={() => {
                          handleInsertData("country", "")
                          toggleDropdown("country");
                        }}
                      >
                        --- Select ---
                      </li>

                      <li className="vectoraarowdivomgulmaili"
                        onClick={() => {
                          handleInsertData("country", "65f95f070d6753c3bdacccd9")
                          toggleDropdown("country");
                        }}
                      >
                        United Arab Emirates
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div> */}
            <select className="neooSelect"
              value={filterKey?.country}
              onClick={(e) => {
                handleInsertData("country", e.target.value)
              }}
              style={{
                height: "44px",
                padding: "5px 10px 5px 20px",
                fontSize: "15px"
              }}
            >
              <option value="">Choose...</option>
              {
                country
                  .map((item, key) => {
                    return (
                      <><option value={item?._id}>{item?.name}</option></>
                    )
                  })
              }
            </select>
          </div>

          <div className="keywirdrserchttxtdibgflx">
            <div className="keywirdrserchdibvnain">
              <p className="keywirdrserchdibvnainttxpp">State</p>
            </div>
            {/* <div className="keywirdrserchdibinpiuytxtdiv">
              <div className="keywirdrserchdibderselect">
                <p className="selrcttcatreffgtxtpp">{filterKey?.state || "--- Select ---"}</p>
                <div
                  className="vectorimgamindiv"
                  onClick={() => toggleDropdown("state")}
                >
                  <img src={vectorarrow} alt="..." />
                </div>
                {activeDropdown === "state" && (
                  <div className="vectoraarowdivomgulmai">
                    <ul className="vectoraarowdivomgulmaiul">
                      <li
                        className="vectoraarowdivomgulmaili"
                        onClick={() => {
                          handleInsertData("state", "")
                          toggleDropdown("state");
                        }}
                      >
                        --- Select ---
                      </li>
                      {countryStates.map((state, index) => (
                        <li
                          key={index}
                          className="vectoraarowdivomgulmaili"
                          onClick={() => {
                            handleInsertData("state", state?.name)
                            toggleDropdown("state");
                          }}
                        >
                          {state?.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div> */}
            <select className="neooSelect"
              name="emirate"
              value={filterKey.emirate}
              onChange={(e) =>
                handleInsertData("state", e.target.value)
              }
              style={{
                height: "44px",
                padding: "5px 10px 5px 20px",
                fontSize: "15px"
              }}
            >
              <option value="">Choose...</option>
              {
                countryStates?.map((item) => {
                  return (
                    <><option value={item.name}>{item.name}</option></>
                  )
                })
              }
            </select>
          </div>

          <div className="cancelbscearchbtntndiv">
            <button className="cancelbtn"
              onClick={() => {
                setFilterKey(initialData)
                setViewAll(true)
                setViewPremiumMembers(false)
                setViewVerifiedList(false)
                setSelectedOption("all")
                closemodal()
              }}
            >Cancel</button>
            <button className="scearchbtn" onClick={handlearrpwclick}>Search</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ownpagesearchkeywordmodal;
